/* eslint-disable sonarjs/no-duplicated-branches */
export const PropertyChanged = (src, dest) => {
    let changed = false;
    const srcKeys = Object.keys(src);
    for (const key of srcKeys) {
        if (Array.isArray(src[key]) && src[key] !== dest[key]) {
            dest[key] = src[key];
            changed = true;
        }
        else if (typeof src[key] === "object" && src[key] !== null) {
            if (typeof dest[key] === 'undefined') {
                dest[key] = {};
            }
            changed = PropertyChanged(src[key], dest[key]) || changed;
        }
        else if (src[key] !== dest[key]) {
            dest[key] = src[key];
            changed = true;
        }
    }
    const destKeys = Object.keys(dest);
    for (const key of destKeys) {
        if (typeof src[key] === "undefined") {
            dest[key] = undefined;
        }
    }
    return changed;
};
export function ObjectDiff(prevState, curState) {
    const changes = {};
    for (const prop in curState) {
        const isMapType = curState[prop] instanceof Map;
        if ((isMapType && curState[prop].size !== prevState[prop].size)
            || (prevState[prop] !== curState[prop])) {
            changes[prop] = `Old value: ${String(prevState[prop])}, New value: ${String(curState[prop])}`;
        }
    }
    return changes;
}
export function getObjectStringPropValue(obj, prop) {
    return obj[prop];
}
const iterateObject = (objName, obj, condition, propNames) => {
    Object.keys(obj).forEach((x) => {
        if (!condition((obj)[x])) {
            propNames.push(objName ? `${objName}.${x}` : x);
        }
        else if (typeof obj[x] === "object") {
            iterateObject(x, obj[x], condition, propNames);
        }
    });
};
export const MissingObjectPropValues = (obj) => {
    const missingProps = [];
    iterateObject("", obj, (value) => !!(value === 0 || value), missingProps);
    return missingProps;
};
